import LeadTimeActivity from './LeadTimeActivity.component';

export default LeadTimeActivity;
